interface PeopleAndCheckmarkSVGProps {
  color: string;
  style: React.CSSProperties;
}

const PeopleAndCheckmarkSVG = ({
  color,
  style,
}: PeopleAndCheckmarkSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="49"
    height="52"
    viewBox="0 0 49 52"
    fill="none"
  >
    <path
      d="M10.7399 35.9768C12.6967 35.9768 14.283 34.3339 14.283 32.3072C14.283 30.2805 12.6967 28.6375 10.7399 28.6375C8.78309 28.6375 7.19678 30.2805 7.19678 32.3072C7.19678 34.3339 8.78309 35.9768 10.7399 35.9768Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5308 45.2526C17.5308 45.2526 17.201 38.128 12.9907 37.9976C11.269 37.9439 9.77732 37.9631 8.52725 37.99C4.14053 38.0743 4.18654 45.2986 4.18654 45.2986C4.18654 45.9428 7.17366 46.4681 10.8587 46.4681C14.5437 46.4681 17.5308 45.9466 17.5308 45.2986C17.5308 45.2833 17.5308 45.2679 17.5231 45.2526H17.5308Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M40.6684 35.9768C42.6252 35.9768 44.2115 34.3339 44.2115 32.3072C44.2115 30.2805 42.6252 28.6375 40.6684 28.6375C38.7116 28.6375 37.1252 30.2805 37.1252 32.3072C37.1252 34.3339 38.7116 35.9768 40.6684 35.9768Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M47.4595 45.2526C47.4595 45.2526 47.1297 38.128 42.9194 37.9976C41.1977 37.9439 39.706 37.9631 38.456 37.99C34.0692 38.0743 34.1153 45.2986 34.1153 45.2986C34.1153 45.9428 37.1024 46.4681 40.7874 46.4681C44.4724 46.4681 47.4595 45.9466 47.4595 45.2986C47.4595 45.2833 47.4595 45.2679 47.4518 45.2526H47.4595Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.7904 8.74772C27.7473 8.74772 29.3336 7.10475 29.3336 5.07805C29.3336 3.05135 27.7473 1.40839 25.7904 1.40839C23.8336 1.40839 22.2473 3.05135 22.2473 5.07805C22.2473 7.10475 23.8336 8.74772 25.7904 8.74772Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.5813 18.0235C32.5813 18.0235 32.2515 10.8989 28.0412 10.7685C26.3195 10.7148 24.8279 10.734 23.5778 10.7608C19.1911 10.8452 19.2371 18.0695 19.2371 18.0695C19.2371 18.7137 22.2242 19.239 25.9092 19.239C29.5942 19.239 32.5813 18.7175 32.5813 18.0695C32.5813 18.0541 32.5813 18.0388 32.5736 18.0235H32.5813Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M36.4695 12.6858C37.9688 13.5754 39.3492 14.6452 40.5725 15.8723C42.4437 17.7436 43.9584 19.9714 45.0014 22.4447C45.3503 23.273 45.6494 24.1281 45.891 25.0062"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.96948 25.1787C6.21873 24.2392 6.53316 23.3266 6.90511 22.4408C7.95195 19.9676 9.46659 17.7397 11.334 15.8684C12.3962 14.8063 13.5772 13.8553 14.8503 13.0424"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M34.0002 49.5396C31.5269 50.5864 28.8082 51.1655 25.9553 51.1655C23.1024 51.1655 20.3837 50.5864 17.9104 49.5396"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.0637 25.8114C32.7884 26.3866 32.8881 27.4526 32.2823 28.1505L25.2114 36.3334C25.1424 36.4331 25.0081 36.4446 24.9199 36.3641L19.4557 32.1729C18.7502 31.6323 18.6083 30.62 19.1413 29.9067C19.6819 29.182 20.7134 29.0363 21.4305 29.5846L24.5096 31.9275C24.5978 32.0081 24.7321 31.9927 24.8011 31.8969L29.786 26.0185C30.3535 25.3474 31.3505 25.2516 32.0407 25.7961L32.0637 25.8114Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default PeopleAndCheckmarkSVG;
